import { Component, ViewEncapsulation, OnInit, Input } from '@angular/core';

/**
 * æ é¢ç»ä»¶ - å¸¸ç¨äºå±ç¤ºpanelæ é¢ãæ°æ®åç»æ é¢åå¬åæ é¢ç­ã
 * 
 * <example-url>https://stackblitz.com/edit/np-title-sample?embed=1&file=src/app/app.component.html</example-url>
 */

@Component({
  selector: `np-title`,
  templateUrl: 'title.html',
  styleUrls: ['title.scss'],
  encapsulation: ViewEncapsulation.None
})

export class NpTitle implements OnInit {

  /**é»è®¤æ é¢ - é»è®¤æ­¤æ é¢å¸¦æä¸åçº¿åå·¦ä¾§Plutoè²å ç²border */
  @Input() text: string = '';

  /**å½æ é¢ç±»åä¸ºtextænoticeæ¶çæè¿° - ä»¥å°å­å±ç¤ºä¸æ é¢å³ä¾§ */
  @Input() description: string = '';

  /**æ¯å¦æ¾ç¤ºæ é¢ç±»åä¸ºtextçå·¦ä¾§Plutoè²å ç²border */
  @Input() vBar: boolean = true;

  /**æ¯å¦å ç²æ é¢ç±»åä¸ºtextçæ é¢ */
  @Input() bold: boolean = false;

  /**
   * æ é¢ç±»å
   * 
   * title - å¸¸ç¨äºpanelçæ é¢ï¼é»è®¤å¸¦æå·¦ä¾§å ç²borderåä¸åçº¿
   * 
   * caption - å¸¸ç¨äºåç»å±ç¤ºæ°æ®æ é¢ï¼é»è®¤å¸¦æå·¦ä¾§å ç²border
   * 
   * notice - ç±»ä¼¼å°åå­å¬åï¼é»è®¤å·¦ä¾§æå°åå­å¾æ ï¼æ¥çæ é¢åæè¿°
   */
  @Input() type: 'title' | 'caption' | 'notice' = 'title';

  constructor() { }

  ngOnInit(): void {

  }
}


